import React from "react"
import { Link } from "react-router-dom"
import ModalContainer from "../ModalContainer"

const SuccessPopUp = ({ successTitle, content, successLink }) => {
  return (
    <ModalContainer>
      <div className="bg-white rounded-lg h-80 w-80 p-10">
        <img
          src={require("../../../assets/check.svg").default}
          alt="symbol"
          className="w-28 mx-auto -mt-24"
        />

        <h3 className="mt-16 text-center text-xl font-medium">{content}</h3>

        <Link
          className="bg-sbg-light-green py-2 px-3 text-white mt-16 mx-auto rounded-lg block text-center"
          to={successLink}
        >
          {successTitle}
        </Link>
      </div>
    </ModalContainer>
  )
}

export default SuccessPopUp
